/**
 * Modular What's New entries for the "teamChat" module: partner-restaurant channels. `routes` use the real
 * navigation screen name from AppNavigator.jsx (the Team Chat hub).
 *
 * @type {Object[]}
 */
const teamChatEntries = [
  {
    id: 'teamchat-partner-restaurants-2026-10',
    module: 'teamChat',
    routes: ['ChatHomeScreen'],
    date: '2026-10-20',
    version: '4.16.0',
    global: false,
    type: 'feature',
    title: {
      en: "🤝 Chat with partner restaurants",
      hu: "🤝 Csevegés a partner éttermekkel",
      de: "🤝 Chatten mit Partnerrestaurants",
      cn: "🤝 与合作餐厅聊天",
      ro: "🤝 Discută cu restaurantele partenere",
      svn: "🤝 Klepet s partnerskimi restavracijami",
    },
    body: {
      en: "Reaching a partner restaurant meant e-mail or phone calls outside Team Chat. Now, when you create a channel, choose the new Restaurant type, pick a restaurant and invite the restaurant users you want to talk to. Only invited users can read and reply from their own Team Chat, and you can invite more people later.",
      hu: "Egy partner étteremmel eddig e-mailben vagy telefonon kellett egyeztetni, a Csapatchaten kívül. Mostantól csatorna létrehozásakor az új Étterem típust választva kiválaszthatsz egy éttermet, és meghívhatod azokat az étterem-felhasználókat, akikkel beszélnél. Csak a meghívottak olvashatnak és válaszolhatnak a saját Csapatchatjükből, és később további embereket is meghívhatsz.",
      de: "Der Kontakt zu einem Partnerrestaurant lief bisher per E-Mail oder Telefon außerhalb des Team-Chats. Jetzt wählen Sie beim Erstellen eines Kanals den neuen Typ Restaurant, suchen ein Restaurant aus und laden die gewünschten Restaurantnutzer ein. Nur eingeladene Nutzer können in ihrem eigenen Team-Chat lesen und antworten; weitere Personen lassen sich später einladen.",
      cn: "以前联系合作餐厅只能通过邮件或电话，无法在团队聊天中完成。现在创建频道时选择新的“餐厅”类型，选出餐厅并邀请你想沟通的餐厅用户。只有受邀用户可以在自己的团队聊天中阅读和回复，之后还可以邀请更多人。",
      ro: "Contactarea unui restaurant partener însemna e-mail sau telefon, în afara chatului de echipă. Acum, la crearea unui canal, alege noul tip Restaurant, selectează un restaurant și invită utilizatorii restaurantului cu care vrei să vorbești. Doar utilizatorii invitați pot citi și răspunde din propriul chat de echipă, iar mai târziu poți invita și alte persoane.",
      svn: "Stik s partnersko restavracijo je pomenil e-pošto ali klice zunaj skupinskega klepeta. Zdaj ob ustvarjanju kanala izberi novo vrsto Restavracija, izberi restavracijo in povabi uporabnike restavracije, s katerimi želiš govoriti. Berejo in odgovarjajo lahko samo povabljeni v svojem skupinskem klepetu, druge pa lahko povabiš kasneje.",
    },
  },
];

export default teamChatEntries;
